var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "a-form",
        { staticClass: "UniformCss", attrs: { "laba-width": "110px" } },
        [
          _c(
            "a-row",
            { attrs: { gutter: 10 } },
            [
              _vm.type === 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c("a-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.data.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "applyOrderCode", $$v)
                              },
                              expression: "data.applyOrderCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领部门" } },
                        [
                          _c("a-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.data.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "orgName", $$v)
                              },
                              expression: "data.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领人" } },
                        [
                          _c("a-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.data.drawMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "drawMan", $$v)
                              },
                              expression: "data.drawMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "物料号" } },
                    [
                      _c("a-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.data.materialCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "materialCode", $$v)
                          },
                          expression: "data.materialCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "物料名称" } },
                    [
                      _c("a-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.data.materialName,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "materialName", $$v)
                          },
                          expression: "data.materialName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "物料类型" } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.data.materialType,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "materialType", $$v)
                            },
                            expression: "data.materialType",
                          },
                        },
                        _vm._l(_vm.list.PromotionMaterialType, function (item) {
                          return _c(
                            "a-select-option",
                            { key: item.code, attrs: { value: item.code } },
                            [_vm._v(_vm._s(item.value))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.type != 0 && _vm.type != 1 && _vm.type != 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "单位" } },
                        [
                          _c("a-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.data.unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "unit", $$v)
                              },
                              expression: "data.unit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 1
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "入库时间" } },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              valueFormat: "YYYY-MM-DD",
                              type: "date",
                              placeholder: "选择日期",
                            },
                            on: {
                              change: function ($event) {
                                _vm.data.enddateEnd
                                  ? (_vm.data.begindateEnd = "")
                                  : ""
                              },
                            },
                            model: {
                              value: _vm.data.begindateStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "begindateStart", $$v)
                              },
                              expression: "data.begindateStart",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "出库时间" } },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              valueFormat: "YYYY-MM-DD",
                              type: "date",
                              placeholder: "选择日期",
                            },
                            on: {
                              change: function ($event) {
                                _vm.data.enddateEnd
                                  ? (_vm.data.begindateEnd = "")
                                  : ""
                              },
                            },
                            model: {
                              value: _vm.data.begindateStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "begindateStart", $$v)
                              },
                              expression: "data.begindateStart",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 1 || _vm.type === 2
                ? _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "至" } },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              valueFormat: "YYYY-MM-DD",
                              type: "date",
                              placeholder: "选择日期",
                              "picker-options": {
                                disabledDate: function (time) {
                                  return (
                                    time.getTime() <
                                    new Date(_vm.data.begindateStart) - 8.64e7
                                  )
                                },
                              },
                            },
                            model: {
                              value: _vm.data.begindateEnd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "begindateEnd", $$v)
                              },
                              expression: "data.begindateEnd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }